import { IconSet } from '@postscript/components';
import { PERMISSIONS } from 'components/account/AccountView/users/constants';
import {
  PS_LABS,
  USAGE_BILLING_ENABLED,
} from 'components/admin/utils/feature-flags';
import { useMemo } from 'react';
import { User } from 'types';
import { NavMenuItem } from '../NavMenu';

export const useAccountMenuItems = (user: User): NavMenuItem[] => {
  return useMemo(
    () => [
      {
        id: 'account',
        label: user?.shop_name ?? 'Account',
        icon: IconSet.Settings2,
        isLoading: false,
        ariaLabelledBy: 'nav-account-title',
        subMenu: [
          {
            link: '$selectShop',
            label: 'Select Shop',
            id: 'account-select-shop',
          },
          {
            link: '/account/settings',
            label: 'Shop Settings',
            id: 'account-settings',
            restrictions: [PERMISSIONS.limit_sms_sales_agent_access],
          },
          {
            link: '/profile',
            label: 'Profile',
            id: 'profile',
          },
          {
            link: '/account/users',
            label: 'Users',
            id: 'account-users',
            permission: PERMISSIONS.user_read,
            restrictions: [PERMISSIONS.limit_sms_sales_agent_access],
          },
          {
            link: '/account/tracking',
            label: 'Tracking',
            id: 'account-tracking',
            restrictions: [PERMISSIONS.limit_sms_sales_agent_access],
          },
          {
            link: '/account/plan',
            label: 'Plan',
            id: 'account-plan',
            featureFlag: USAGE_BILLING_ENABLED,
            featureFlagOptOut: true,
            restrictions: [PERMISSIONS.limit_sms_sales_agent_access],
          },
          {
            link: '/account/billing',
            label: 'Billing',
            id: 'account-billing',
            featureFlag: USAGE_BILLING_ENABLED,
            featureFlagOptOut: true,
            restrictions: [PERMISSIONS.limit_sms_sales_agent_access],
          },
          {
            link: '/billing',
            label: 'Billing',
            id: 'account-usage-billing',
            featureFlag: USAGE_BILLING_ENABLED,
            permission: PERMISSIONS.billing_read,
            restrictions: [PERMISSIONS.limit_sms_sales_agent_access],
          },
          {
            link: '/account/api',
            label: 'API',
            id: 'account-api',
            restrictions: [PERMISSIONS.limit_sms_sales_agent_access],
          },
          {
            link: '/account/ps-labs',
            label: 'PS Labs',
            id: 'account-ps-labs',
            featureFlag: PS_LABS,
            restrictions: [PERMISSIONS.limit_sms_sales_agent_access],
          },
          {
            link: '/account/contact-card',
            label: 'Shop Contact Card',
            id: 'account-contact-card',
            restrictions: [PERMISSIONS.limit_sms_sales_agent_access],
          },
          {
            link: '/subscriber-list-uploads',
            label: 'Subscriber List Uploads',
            id: 'subscriber-list-uploads',
          },
          { link: '$logOut', label: 'Logout', id: 'account-logout' },
        ],
      },
    ],
    [user],
  );
};
